module.exports = __webpack_public_path__ + "images/backgrounds/fall/full.6818cd16880fb3f9f2c8.jpg";